import { Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { TotemWidget, TotemWidgetProductsFilter } from '../totem-widget';
import { EFProduct, EFSupplier } from 'pg-lib/models/experience.model';
import { AnalyticsService } from 'pg-lib/services/analytics.service';
import { EFDataService } from 'pg-lib/services/ef-data.service';
import { PGUtilities } from 'pg-lib/utilities/pg-utilities';

@Component({
    selector: 'app-totem-widget-text',
    templateUrl: './totem-widget-text.component.html',
    styleUrls: ['./totem-widget-text.component.scss'],
    standalone: false
})
export class TotemWidgetTextComponent extends TotemWidget implements OnInit, OnChanges {

    constructor(public elementRef:ElementRef, private analyticsService:AnalyticsService, private efDataService:EFDataService) {
        super(elementRef)
    }

    @Input() size:'md'|'lg' = 'md'

    @Input() productsData:Array<EFProduct>;

    @Input() abstract:string
    @Input() subAbstract:string
    @Input() logo:string
    @Input() logoInvert:boolean
    @Input() cover:string
    @Input() text:string
    @Input() background:string
    @Input() abstractColor:string
    @Input() link:string
    @Input() showProducts:boolean
    @Input() productsFilter:TotemWidgetProductsFilter

    /** Action-card mode (totem-application): emergency / survey style cards. */
    @Input() overtitle:string;
    @Input() title:string;
    @Input() description:string;
    @Input() color:string;
    @Input() actionList:Array<{ icon?:string, text:string, link?:string, color?:string }>;

    filteredData:Array<EFProduct>;

    fullScreenText:string = null;

    ngOnInit(): void {
        if(this.size == null) this.size = 'md'

        this._checkInitializeWidget();
    }

    isActionCard() {
        return this.actionList != null || this.title != null || this.description != null || this.overtitle != null;
    }

    goToLink(link:string) {
        if(!link) return;

        this.analyticsService.sendEvent('widgetOpenLink', {
            widget: this.id,
            link: link
        })

        window.open(link)
    }

    ngOnChanges() {
        this._checkInitializeWidget();
    }
    
    isInitialized = false;

    private _checkInitializeWidget() {
        if(!this.isInitialized && this.productsData != null) {
            this.isInitialized = true;

            this.fullScreenText = '<div class="card"><div class="card-body">' + this.text + '</div></div>';
            this.fullScreenText = this.fullScreenText
                .replace(/<figure/g,'</div></div><div class="card"><figure')
                .replace(/\/figure>/g,'/figure></div><div class="card"><div class="card-body">')

            this.filteredData = null;

            if(this.fullScreen && this.showProducts) {
                this.filteredData = this.applyProductsFilter(this.productsData, this.productsFilter)
            }
        }
    }

    isImage(val:string) {
        return /^http/.test(val)
    }

    onWidgetClick() {
        if(this.link) {
            window.open(this.link)

            this.analyticsService.sendEvent('widgetOpenLink', {
                widget: this.id,
                link: this.link
            })
        }
        else {
            this.requestFullScreen.emit()
        }
    }

    onCardActivate() {
        this.onWidgetClick();
    }

    getBackgroundClass() {
        if(PGUtilities.isValidColorClass(this.background)) return this.background
    }

    getBackgroundStyle() {
        if(!PGUtilities.isValidColorClass(this.background)) return this.background
    }

    getAbstractColorClass() {
        if(this.abstractColor) {
            if(PGUtilities.isValidColorClass(this.abstractColor)) return this.abstractColor
        }
        else if(this.background) {
            return 'white'
        }
    }

    getAbstractColorStyle() {
        if(this.abstractColor) {
            if(!PGUtilities.isValidColorClass(this.abstractColor)) return this.abstractColor
        }
    }

    selectedProductId:string = null;

    selectedProductData:EFProduct = null;
    selectedProductSupplierData:EFSupplier = null;

    isLoadingProduct = false;

    onShowProduct(product:string) {
        this.selectedProductId = product;

        this.isLoadingProduct = true;

        this.efDataService.getProductDetail(this.selectedProductId).subscribe((data) => {

            this.selectedProductData = data;

            if(data?.analytics != null) {
                this.analyticsService.sendEvent('showProduct', data.analytics)
            }

            if(this.selectedProductData != null && this.selectedProductData.supplier != null) {
                let _supplierSplit = this.selectedProductData.supplier.split('_');

                this.efDataService.getResourceSupplier(_supplierSplit[0], _supplierSplit[1]).subscribe((data) => {
                    this.selectedProductSupplierData = data;
                    this.isLoadingProduct = false;
                })
            }
            else {
                this.isLoadingProduct = false;
            }
        })
    }
}
